import { createTheme } from '@mui/material/styles';

export const getTheme = (toggleDarkMode: boolean) =>
    createTheme({
        palette: {
            mode: !toggleDarkMode ? 'dark' : 'light',

            ...(!toggleDarkMode
                ? {
                      // 🌙 DARK MODE (ChatGPT-inspired)
                      text: {
                          primary: '#e5e7eb',
                          secondary: '#9ca3af',
                      },
                      divider: '#1f2937',
                      background: {
                          paper: '#4c4a4a',
                          default: 'rgba(51,50,50,0.95)',
                      },
                  }
                : {
                      // ☀️ LIGHT MODE (clean + soft green vibe)
                      primary: {
                          main: '#10a37f',
                      },
                      background: {
                          default: '#f9fafb',
                          paper: 'rgba(203,203,203,0.45)',
                      },
                      text: {
                          primary: '#111827',
                          secondary: '#4b5563',
                      },
                      divider: '#e5e7eb',
                  }),
        },

        typography: {
            fontFamily: `'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
        },
    });
